import { Edit, Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import AttributeCoverageTag from 'components/common/rfq/AttributeCoveredTag';
import PlanAttributeBlock from 'components/common/rfq/PlanAttributeBlock';
import useRfqTemplate from 'global/hooks/useRfqTemplate';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { AttributeInfo } from 'store/modules/uwProducts/uwProductsModule';
import { useRFQPlanAttributesPageStore } from 'store/pages/rfq/rfq-template/plan-attributes/pageStore';
import { PlanAttributeCategory } from 'types/productServiceV2';
import { RFQ_PLAN_ACTION_BTN_TEST_ID } from '../../constants';
import { AttributeButtonStyled } from './styles';

interface PlanAttributesListProps {
  attributesInfo: AttributeInfo[];
  isStepConfigurable: boolean;
  isCustomAttribute: boolean;
}

interface PlanActionButtonProps {
  isAttributeInfoFilled: boolean;
  domainAttribute: string;
  attributeCategory: PlanAttributeCategory;
}

const PlanActionButton = ({
  isAttributeInfoFilled,
  domainAttribute,
  attributeCategory,
}: PlanActionButtonProps): JSX.Element => {
  const history = useHistory();
  const { templateId, pageType } = useRfqTemplate();

  const onConfigureAttribute = (): void => {
    history.push(
      `/configure-attribute/${templateId}?attributeId=${domainAttribute}&attributeCategory=${PlanAttributeCategory[attributeCategory]}&type=${pageType}`,
    );
  };

  return (
    <AttributeButtonStyled
      type="text"
      color="primary"
      onClick={onConfigureAttribute}
      leftIconProp={isAttributeInfoFilled ? <Edit /> : <Add />}
      data-test-id={RFQ_PLAN_ACTION_BTN_TEST_ID}
    >
      {isAttributeInfoFilled ? 'Edit Attribute' : 'Configure Attribute'}
    </AttributeButtonStyled>
  );
};

const PlanAttributesList: React.FC<PlanAttributesListProps> = observer(
  ({ attributesInfo, isStepConfigurable, isCustomAttribute }) => {
    const {
      showCustomAttributesFeature,
      removeAttributeModalDelegate: { openRemoveAttributeModal },
    } = useRFQPlanAttributesPageStore();
    const enabledAttributeFeatureStatus = isCustomAttribute ? 'ENABLED' : 'DISABLED';
    const attributeCategory = isCustomAttribute ? PlanAttributeCategory.CUSTOM : PlanAttributeCategory.REQUIRED;

    return (
      <>
        {attributesInfo.map(({ name, engValues, formValues, maxWaiverMessage, isCovered, type }) => {
          return (
            <PlanAttributeBlock
              key={name}
              label={name}
              headerElement={
                isStepConfigurable ? (
                  <PlanActionButton
                    isAttributeInfoFilled={!!engValues}
                    domainAttribute={name}
                    attributeCategory={attributeCategory}
                  />
                ) : (
                  <AttributeCoverageTag isAttributeCovered={isCovered} />
                )
              }
              planAttribute={formValues}
              engValues={engValues}
              planType={type}
              maxWaiverMessage={maxWaiverMessage}
              removeAttrButtonStatus={
                showCustomAttributesFeature && isStepConfigurable ? enabledAttributeFeatureStatus : 'HIDDEN'
              }
              onRemoveAttribute={(label: string): void => {
                if (isCustomAttribute) void openRemoveAttributeModal(label);
              }}
            />
          );
        })}
      </>
    );
  },
);

export default PlanAttributesList;
